// AUTO-GENERATED — do not edit. Run npm run codegen:flags to regenerate.

export type FlagName =
  | 'innovate.fe.runner.page'
  | 'innovate.fe.composer.page'
  | 'innovate.fe.interface.assistant-entry'
  | 'innovate.fe.testing.sections'
  | 'innovate.fe.testing.criteria'
  | 'innovate.fe.testing.runs'
  | 'innovate.fe.testing.scenarios.import-export'
  | 'innovate.fe.testing.compare.page'
  | 'innovate.fe.testing.assistant-handoff'
  | 'innovate.fe.assistant.testingCards'
  | 'innovate.fe.assistant.criteriaCard'
  | 'innovate.fe.assistant.actions'
  | 'innovate.fe.assistant.history'
  | 'innovate.fe.tests.delete'
  | 'innovate.fe.agents.page'
  | 'innovate.fe.agents.create'
  | 'innovate.fe.agents.redesign'
  | 'innovate.fe.configs.page'
  | 'innovate.fe.configs.create'
  | 'innovate.fe.configs.builder'
  | 'innovate.fe.collaborations.page'
  | 'innovate.fe.run-explorer.page'
  | 'innovate.fe.endpoints.page'
  | 'innovate.fe.endpoints.create'
  | 'innovate.fe.endpoints.runs-tab'
  | 'innovate.fe.endpoints.api-docs-tab'
  | 'innovate.fe.prompts.page'
  | 'innovate.fe.prompts.create'
  | 'innovate.fe.model-catalog.page'
  | 'innovate.fe.model-catalog.manage'
  | 'innovate.fe.model-catalog.platform-keys'
  | 'innovate.fe.models.review'
  | 'innovate.fe.model-configs.create'
  | 'innovate.fe.mcp-connections.page'
  | 'innovate.fe.mcp-connections.create'
  | 'innovate.fe.message-routes.page'
  | 'innovate.fe.message-routes.create'
  | 'innovate.fe.billing.page'
  | 'innovate.fe.settings-billing.page'
  | 'innovate.fe.spending.page'
  | 'innovate.fe.home.page'
  | 'innovate.fe.endpoints.queued'
  | 'innovate.fe.endpoints.tests'
  | 'innovate.fe.dashboard.page'
  | 'innovate.fe.services.page'
  | 'innovate.fe.services.new.page'
  | 'innovate.fe.services.run-detail.page'
  | 'innovate.fe.services.config-tab'
  | 'innovate.fe.services.runs-tab'
  | 'innovate.fe.services.analytics-first'
  | 'innovate.fe.services.interface-tab'
  | 'innovate.fe.services.testing-tab'
  | 'innovate.fe.services.releases-tab'
  | 'innovate.fe.analytics-tab'
  | 'innovate.fe.analytics.per-run-cost'
  | 'innovate.fe.services.stop'
  | 'innovate.fe.services.access'
  | 'innovate.fe.email-privacy.page'
  | 'innovate.fe.profile.page'
  | 'innovate.fe.settings-preferences.page'
  | 'innovate.fe.settings-security.page'
  | 'innovate.fe.settings-subscription.page'
  | 'innovate.fe.settings-payment.page'
  | 'innovate.fe.settings-account.page'
  | 'innovate.fe.account.manage'
  | 'innovate.fe.account.models'
  | 'innovate.fe.account.spending'
  | 'innovate.fe.account.team'
  | 'innovate.fe.settings-team.page'
  | 'innovate.fe.invite-accept.page'
  | 'innovate.fe.dashboard.onboarding'
  | 'innovate.fe.help.explainers'
  | 'innovate.fe.help.menu'
  | 'innovate.fe.help.assistant'
  | 'innovate.fe.knowledge.documents.page'
  | 'innovate.fe.knowledge.documents.create'
  | 'innovate.fe.knowledge.bases.page'
  | 'innovate.fe.artifacts.page'
  | 'innovate.fe.knowledge.bases.create'
  | 'innovate.fe.knowledge.agent-attachment'
  | 'innovate.fe.resource-versioning'
  | 'innovate.fe.versioning.publish'
  | 'innovate.fe.versioning.diff'
  | 'innovate.fe.assistant.sidebar'
  | 'innovate.fe.assistant.documentAttach'
  | 'innovate.fe.environments.manage'
  | 'innovate.fe.environments.rollout'
  | 'innovate.fe.services.developer-tab'
  | 'innovate.fe.custom-domains.manage'
  | 'innovate.fe.service-exposure.manage'
  | 'innovate.fe.services.delete'
  | 'innovate.fe.agents.delete'
  | 'innovate.fe.prompts.delete'
  | 'innovate.fe.configs.delete'
  | 'innovate.fe.mcp-connections.delete'
  | 'innovate.fe.message-routes.delete'
  | 'innovate.fe.model-configs.delete'
  | 'innovate.fe.knowledge.bases.delete'
  | 'innovate.fe.knowledge.documents.delete'
  | 'innovate.fe.knowledge.documents.view'
  | 'innovate.fe.artifacts.delete'
  | 'innovate.fe.environments.delete'
  | 'innovate.fe.archive.page'
  | 'innovate.fe.archive.restore'
  | 'innovate.fe.settings-api-keys.page'
  | 'innovate.fe.settings-api-keys.manage'
  | 'innovate.fe.settings-account-models.page'
  | 'innovate.fe.plan.no-plan-notices'
  | 'innovate.fe.dashboard.service-cost'
  | 'innovate.fe.assistant.specCard'
  | 'innovate.fe.assistant.optionChips'
  | 'innovate.fe.assistant.resultCard'
  | 'innovate.fe.services.access-badge'
  | 'innovate.fe.services.path-chip'
  | 'innovate.fe.schedules.manage'
  | 'innovate.fe.schedules.delete';

export const KNOWN_FLAG_NAMES: readonly FlagName[] = [
  'innovate.fe.runner.page',
  'innovate.fe.composer.page',
  'innovate.fe.interface.assistant-entry',
  'innovate.fe.testing.sections',
  'innovate.fe.testing.criteria',
  'innovate.fe.testing.runs',
  'innovate.fe.testing.scenarios.import-export',
  'innovate.fe.testing.compare.page',
  'innovate.fe.testing.assistant-handoff',
  'innovate.fe.assistant.testingCards',
  'innovate.fe.assistant.criteriaCard',
  'innovate.fe.assistant.actions',
  'innovate.fe.assistant.history',
  'innovate.fe.tests.delete',
  'innovate.fe.agents.page',
  'innovate.fe.agents.create',
  'innovate.fe.agents.redesign',
  'innovate.fe.configs.page',
  'innovate.fe.configs.create',
  'innovate.fe.configs.builder',
  'innovate.fe.collaborations.page',
  'innovate.fe.run-explorer.page',
  'innovate.fe.endpoints.page',
  'innovate.fe.endpoints.create',
  'innovate.fe.endpoints.runs-tab',
  'innovate.fe.endpoints.api-docs-tab',
  'innovate.fe.prompts.page',
  'innovate.fe.prompts.create',
  'innovate.fe.model-catalog.page',
  'innovate.fe.model-catalog.manage',
  'innovate.fe.model-catalog.platform-keys',
  'innovate.fe.models.review',
  'innovate.fe.model-configs.create',
  'innovate.fe.mcp-connections.page',
  'innovate.fe.mcp-connections.create',
  'innovate.fe.message-routes.page',
  'innovate.fe.message-routes.create',
  'innovate.fe.billing.page',
  'innovate.fe.settings-billing.page',
  'innovate.fe.spending.page',
  'innovate.fe.home.page',
  'innovate.fe.endpoints.queued',
  'innovate.fe.endpoints.tests',
  'innovate.fe.dashboard.page',
  'innovate.fe.services.page',
  'innovate.fe.services.new.page',
  'innovate.fe.services.run-detail.page',
  'innovate.fe.services.config-tab',
  'innovate.fe.services.runs-tab',
  'innovate.fe.services.analytics-first',
  'innovate.fe.services.interface-tab',
  'innovate.fe.services.testing-tab',
  'innovate.fe.services.releases-tab',
  'innovate.fe.analytics-tab',
  'innovate.fe.analytics.per-run-cost',
  'innovate.fe.services.stop',
  'innovate.fe.services.access',
  'innovate.fe.email-privacy.page',
  'innovate.fe.profile.page',
  'innovate.fe.settings-preferences.page',
  'innovate.fe.settings-security.page',
  'innovate.fe.settings-subscription.page',
  'innovate.fe.settings-payment.page',
  'innovate.fe.settings-account.page',
  'innovate.fe.account.manage',
  'innovate.fe.account.models',
  'innovate.fe.account.spending',
  'innovate.fe.account.team',
  'innovate.fe.settings-team.page',
  'innovate.fe.invite-accept.page',
  'innovate.fe.dashboard.onboarding',
  'innovate.fe.help.explainers',
  'innovate.fe.help.menu',
  'innovate.fe.help.assistant',
  'innovate.fe.knowledge.documents.page',
  'innovate.fe.knowledge.documents.create',
  'innovate.fe.knowledge.bases.page',
  'innovate.fe.artifacts.page',
  'innovate.fe.knowledge.bases.create',
  'innovate.fe.knowledge.agent-attachment',
  'innovate.fe.resource-versioning',
  'innovate.fe.versioning.publish',
  'innovate.fe.versioning.diff',
  'innovate.fe.assistant.sidebar',
  'innovate.fe.assistant.documentAttach',
  'innovate.fe.environments.manage',
  'innovate.fe.environments.rollout',
  'innovate.fe.services.developer-tab',
  'innovate.fe.custom-domains.manage',
  'innovate.fe.service-exposure.manage',
  'innovate.fe.services.delete',
  'innovate.fe.agents.delete',
  'innovate.fe.prompts.delete',
  'innovate.fe.configs.delete',
  'innovate.fe.mcp-connections.delete',
  'innovate.fe.message-routes.delete',
  'innovate.fe.model-configs.delete',
  'innovate.fe.knowledge.bases.delete',
  'innovate.fe.knowledge.documents.delete',
  'innovate.fe.knowledge.documents.view',
  'innovate.fe.artifacts.delete',
  'innovate.fe.environments.delete',
  'innovate.fe.archive.page',
  'innovate.fe.archive.restore',
  'innovate.fe.settings-api-keys.page',
  'innovate.fe.settings-api-keys.manage',
  'innovate.fe.settings-account-models.page',
  'innovate.fe.plan.no-plan-notices',
  'innovate.fe.dashboard.service-cost',
  'innovate.fe.assistant.specCard',
  'innovate.fe.assistant.optionChips',
  'innovate.fe.assistant.resultCard',
  'innovate.fe.services.access-badge',
  'innovate.fe.services.path-chip',
  'innovate.fe.schedules.manage',
  'innovate.fe.schedules.delete'
];

export const KNOWN_FLAG_META: Record<FlagName, { type: 'permission' | 'kill-switch' | 'operational' | 'release' | 'experiment'; enabled: boolean; cohorts: readonly string[] }> = {
  'innovate.fe.runner.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.composer.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.interface.assistant-entry': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.testing.sections': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.testing.criteria': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.testing.runs': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.testing.scenarios.import-export': { type: 'release', enabled: false, cohorts: [] },
  'innovate.fe.testing.compare.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.testing.assistant-handoff': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.assistant.testingCards': { type: 'release', enabled: false, cohorts: [] },
  'innovate.fe.assistant.criteriaCard': { type: 'release', enabled: false, cohorts: [] },
  'innovate.fe.assistant.actions': { type: 'release', enabled: false, cohorts: [] },
  'innovate.fe.assistant.history': { type: 'release', enabled: false, cohorts: [] },
  'innovate.fe.tests.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.agents.page': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.agents.create': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.agents.redesign': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.configs.page': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.configs.create': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.configs.builder': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.collaborations.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.run-explorer.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.endpoints.page': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.endpoints.create': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.endpoints.runs-tab': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.endpoints.api-docs-tab': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.prompts.page': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.prompts.create': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.model-catalog.page': { type: 'permission', enabled: true, cohorts: ['role-platform-admin'] },
  'innovate.fe.model-catalog.manage': { type: 'permission', enabled: true, cohorts: ['role-platform-admin'] },
  'innovate.fe.model-catalog.platform-keys': { type: 'permission', enabled: true, cohorts: ['role-platform-admin'] },
  'innovate.fe.models.review': { type: 'permission', enabled: true, cohorts: ['role-platform-admin'] },
  'innovate.fe.model-configs.create': { type: 'permission', enabled: true, cohorts: ['role-platform-admin'] },
  'innovate.fe.mcp-connections.page': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.mcp-connections.create': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.message-routes.page': { type: 'permission', enabled: false, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.message-routes.create': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.billing.page': { type: 'permission', enabled: true, cohorts: ['role-owner'] },
  'innovate.fe.settings-billing.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.spending.page': { type: 'release', enabled: true, cohorts: ['role-owner'] },
  'innovate.fe.home.page': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.endpoints.queued': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.endpoints.tests': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.dashboard.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.new.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.run-detail.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.config-tab': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.runs-tab': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.analytics-first': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.services.interface-tab': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.testing-tab': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.releases-tab': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.analytics-tab': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.analytics.per-run-cost': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.stop': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.services.access': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.email-privacy.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.profile.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.settings-preferences.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.settings-security.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.settings-subscription.page': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.settings-payment.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.settings-account.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.account.manage': { type: 'permission', enabled: true, cohorts: ['role-admin', 'role-owner'] },
  'innovate.fe.account.models': { type: 'permission', enabled: true, cohorts: ['role-admin', 'role-owner'] },
  'innovate.fe.account.spending': { type: 'permission', enabled: true, cohorts: ['role-admin', 'role-owner'] },
  'innovate.fe.account.team': { type: 'permission', enabled: true, cohorts: ['role-admin', 'role-owner'] },
  'innovate.fe.settings-team.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.invite-accept.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.dashboard.onboarding': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.help.explainers': { type: 'release', enabled: false, cohorts: [] },
  'innovate.fe.help.menu': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.help.assistant': { type: 'release', enabled: false, cohorts: [] },
  'innovate.fe.knowledge.documents.page': { type: 'permission', enabled: false, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.knowledge.documents.create': { type: 'permission', enabled: false, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.knowledge.bases.page': { type: 'permission', enabled: false, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.artifacts.page': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.knowledge.bases.create': { type: 'permission', enabled: false, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.knowledge.agent-attachment': { type: 'release', enabled: false, cohorts: [] },
  'innovate.fe.resource-versioning': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.versioning.publish': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.versioning.diff': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.assistant.sidebar': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.assistant.documentAttach': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.environments.manage': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.environments.rollout': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.services.developer-tab': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.custom-domains.manage': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.service-exposure.manage': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.services.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.agents.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.prompts.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.configs.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.mcp-connections.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.message-routes.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.model-configs.delete': { type: 'permission', enabled: true, cohorts: ['role-platform-admin'] },
  'innovate.fe.knowledge.bases.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.knowledge.documents.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.knowledge.documents.view': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.artifacts.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.environments.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.archive.page': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.archive.restore': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] },
  'innovate.fe.settings-api-keys.page': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.settings-api-keys.manage': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.settings-account-models.page': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.plan.no-plan-notices': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.dashboard.service-cost': { type: 'operational', enabled: true, cohorts: [] },
  'innovate.fe.assistant.specCard': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.assistant.optionChips': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.assistant.resultCard': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.services.access-badge': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.services.path-chip': { type: 'operational', enabled: false, cohorts: [] },
  'innovate.fe.schedules.manage': { type: 'release', enabled: true, cohorts: [] },
  'innovate.fe.schedules.delete': { type: 'permission', enabled: true, cohorts: ['role-member', 'role-account-api-key', 'role-admin', 'role-owner'] }
};
